export function titleCase(value: string): string {
  return value.replace(/(^|[\s-])(\p{Ll})/gu, (_, separator: string, letter: string) =>
    `${separator}${letter.toUpperCase()}`,
  )
}
